// extracted by mini-css-extract-plugin
export default {"switch":"SwitchLanguage_switch__mlb47"};